import { Component, OnInit, Input, ViewEncapsulation, EventEmitter, Output } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-single-booking',
    templateUrl: 'booking.component.html',
    styleUrls: ['../../dashboard.component.css', './booking.component.css', './booking.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class BookingComponent implements OnInit {

    @Input() id: number;
    @Input() bookingInfo: any;
    @Input() limitedButtons: boolean;
    @Input() fees;
    @Output() cancelSectionToggled: EventEmitter<any> = new EventEmitter();
    @Output() updateCreditCardDetails: EventEmitter<any> = new EventEmitter();
    @Output() bookingCancelled: EventEmitter<any> = new EventEmitter();
    @Output() bookingRemoved: EventEmitter<any> = new EventEmitter();

    imageHover = '';
    paymentVisible = false;
    cancelVisible = false;

    status: String;
    class: String;
    cardClass = {
        active: 'active-booking',
        past: 'past-booking',
        cancelled: 'cancelled-booking'
    };

    voucherUrl = environment.backendRoot + '/frontend/voucher#';

    constructor() { }

    ngOnInit() {
        this.imageHover = '../../../../../assets/img/view-' + this.bookingInfo.status + '.png';
        this.status = this.bookingInfo.status.trim();
        if (this.status === 'active') { this.class = this.cardClass.active; }
        if (this.status === 'past') { this.class = this.cardClass.past; }
        if (this.status === 'cancelled') { this.class = this.cardClass.cancelled; }
    }

    openVoucher(bookingData) {
        location.href = this.voucherUrl + bookingData.id;
    }

    isVisible(button: string) {
        if (this.bookingInfo.status.trim() === 'cancelled') { return false; }
        if (this.bookingInfo.status.trim() === 'past' && button.trim() !== 'voucher') { return false; }
        if (this.limitedButtons && button.trim() !== 'voucher') { return false; }
        return true;
    }

    togglePaymentDetails() {
        this.paymentVisible = !this.paymentVisible;
        this.cancelVisible = false;
    }

    toggleCancelCard() {
        this.cancelSectionToggled.emit([this.bookingInfo, !this.cancelVisible, this.id]);
        this.cancelVisible = !this.cancelVisible;
        this.paymentVisible = false;
    }

    isPaymentDetailsVisible() {
        return this.paymentVisible;
    }

    isCancelVisible() {
        return this.cancelVisible;
    }

    saveCreditCardInfo(data) {
        data.id = this.bookingInfo.serviceDataId;
        this.updateCreditCardDetails.emit([data, this.bookingInfo.serviceDataId]);
        this.togglePaymentDetails();
    }

    cancelBooking() {
        this.bookingCancelled.emit([this.bookingInfo, this.id]);
    }

    closeBooking() {
        this.cancelVisible = false;
    }

    changeVisibility(visibility) {
        this.paymentVisible = false;
    }

    removeBooking() {
        this.bookingRemoved.emit([this.bookingInfo.id]);
    }

}
